import { WarrantyManagementSlice } from "./WarrantyManagement.slice";

export default WarrantyManagementSlice.reducer;
